import { render, staticRenderFns } from "./table.vue?vue&type=template&id=5c53f0d7"
import script from "./table.vue?vue&type=script&lang=js"
export * from "./table.vue?vue&type=script&lang=js"
import style0 from "./table.vue?vue&type=style&index=0&id=5c53f0d7&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/disk1/buildAgent/work/8268df4d62037a26/vAnalyticsJS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c53f0d7')) {
      api.createRecord('5c53f0d7', component.options)
    } else {
      api.reload('5c53f0d7', component.options)
    }
    module.hot.accept("./table.vue?vue&type=template&id=5c53f0d7", function () {
      api.rerender('5c53f0d7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/vueComponents/table/src/table.vue"
export default component.exports